import { Post } from "@/wp/types/client";
import { ParentsType } from "@/wp/getParentPages";
import { UniversalHeader } from "../UniversalHeader/UniversalHeader";
import { Headline } from "@/components/Headline/Headline";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { Content } from "@/components/Content/Content";
import { HeadersOptionsType } from "@/types/ModuleOptionsType.ts";

export interface JobHeaderProps {
  post: Post<"jobs">;
  headerOptions?: HeadersOptionsType["header_pages"];
  parents: ParentsType;
}

export const JobHeader = ({ post, parents, headerOptions }: JobHeaderProps) => {
  const { header_job } = post.acf;
  const {
    title,
    overline,
    content,
    headline_text_align_class,
    background_color_class,
    section_margin_class,
    seo_settings: { breadcrumb_title } = {},
  } = header_job;

  const contentJSX = (
    <>
      <Headline
        headline={title}
        headline_html_tag="h1-pages"
        extraClass={`is-flex is-flex-direction-column ${headline_text_align_class}`}
        overline={overline}
        disableAnimation
      />
      <Content
        headline=""
        headline_html_tag="h2"
        headline_text_align_class={headline_text_align_class}
        text_align_class={headline_text_align_class}
        button_type="primary"
        text={content}
        link={false}
        isHeader={true}
      />
    </>
  );

  const breadcrumbsJSX = (
    <Breadcrumbs
      extraClass={"breadcrumb"}
      parents={parents}
      breadcrumbPositon={"is-justify-content-flex-start"}
      breadcrumbTitle={breadcrumb_title}
      showOnMobile
    />
  );

  return (
    <UniversalHeader
      type="textheader"
      contentJSX={contentJSX}
      breadcrumbsJSX={breadcrumbsJSX}
      background_color_class={background_color_class}
      section_margin_class={section_margin_class}
      textheaderTextWidth={headerOptions?.textheader.text_width}
    />
  );
};
